<kodit-info-container>
  <div body-full>
    <kodit-paket-info class="kodit-paket-info"></kodit-paket-info>

    <kodit-support-access-request-list class="p-mt-3"></kodit-support-access-request-list>

    <div class="p-mt-5">
      <kodit-korisnicka-grupa-list></kodit-korisnicka-grupa-list>
      <kodit-korisnik-table></kodit-korisnik-table>
    </div>

    <ng-container *ngIf="authService.hasPackage('ROOT')">
      <div class="p-mt-3">
        <p-button
          label="Create test user"
          icon="pi pi-user-plus"
          styleClass="p-button-outlined"
          (onClick)="handleOpenCreateDialog()">
        </p-button>
      </div>
      <kodit-create-support-access-request-dialog
        [(visible)]="showCreateDialog">
      </kodit-create-support-access-request-dialog>
    </ng-container>
  </div>
</kodit-info-container>
